import React from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";

const Header = () => {
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <AppBar position="sticky">
      <Toolbar sx={{ gap: { xs: 3, md: 1 } }}>
        <Box sx={{ flexGrow: 1 }} />
        <Button color="inherit" onClick={() => handleScroll("about")}>
          About
        </Button>
        <Button color="inherit" onClick={() => handleScroll("services")}>
          Services
        </Button>
        <Button color="inherit" onClick={() => handleScroll("projects")}>
          Projects
        </Button>
        <Button color="inherit" onClick={() => handleScroll("skills")}>
          Skills
        </Button>
        <Button color="inherit" onClick={() => handleScroll("contact")}>
          Contact
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
